export default __webpack_public_path__ + "static/media/yellow-card.02342ef9.svg";